module.exports = __webpack_public_path__ + "img/puregym-light-theme.03aea25e.png";